import { Injectable } from '@angular/core';
import {BasicService} from '../../services/basic.service';

@Injectable({
  providedIn: 'root'
})
export class LoginConfigurationService extends BasicService {

  // TODO 租户查询接口
  getTenantId(name) {
    return this.get({
      url: `${this.apiUrl}/api/abp/multi-tenancy/tenants/by-name/${name}`,
    });
  }

  getUserMenus() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/menus`,
    });
  }
  weChatLogin(val) {
    return this.post({
      url: `${this.apiUrl}/api/user/wechat`,
      body: val
    });
  }

  getSMSCode(userName, teantId) {
    return this.post({
      url: `${this.apiUrl}/api/app/smsAuthCode/sendSmsCode`,
      body: { userName },
      headers: {__tenant: teantId ? teantId : ''}
    });
  }

  getSmsAuthCode(tenantId?) {
    return this.get({
      url: `${this.apiUrl}/api/app/smsAuthCode/captcha?tenantId=${tenantId || ''}`,
    });
  }


}
